import { Injectable } from '@angular/core';
import { combineLatest, of, switchMap } from 'rxjs';
import { NotificationActivityApiService } from 'src/app/services/notification-activity.service';
import { NotificationApiService } from 'src/app/services/notification-service';

@Injectable({
  providedIn: 'root',
})
export class MaterialUomDataService {
  public constructor(
    private readonly notificationActivityService: NotificationActivityApiService,
    private readonly notificationService: NotificationApiService
  ) {}

  public set40C(designId: string) {
    return combineLatest([
      this.notificationService.getNotificationNumber(designId),
      this.notificationActivityService.getNextActivityNumber(designId),
    ]).pipe(
      switchMap(([notificationNumber, nextActivityNumber]) => {
        if (!nextActivityNumber) {
          return of(undefined);
        }

        return this.notificationActivityService.postNotificationActivity(
          designId,
          nextActivityNumber,
          notificationNumber.notificationNumber
        );
      })
    );
  }
}
